import AssertionEntity from '../../lib/FormValidator/Assertion/AssertionEntity';
import AssertionItem from '../../lib/FormValidator/Assertion/AssertionItem';
export class OficialAuxiliarOfflineAssertions extends AssertionEntity {
  private constructor() {
    super();
  }

  static build() {
    const instance = new this();
    instance.addAssertionForName();
    instance.addAssertionForLastName();
    instance.addAssertionForDocumentNum();
    instance.addAssertionForOrder();
    return instance;
  }

  addAssertionForName(key = 'oao_nombre') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Nombre es obligatorio'
      )
    );
  }

  addAssertionForLastName(key = 'oao_apellido') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Apellido es obligatorio'
      )
    );
  }

  addAssertionForDocumentNum(key = 'oao_nro_doc') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Número de Documento es obligatorio'
      )
    );
  }

  addAssertionForOrder(key = 'oao_orden') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value;
        },
        key,
        'Orden es obligatorio'
      )
    );
  }
}
